/* eslint-disable react/prop-types */
import React, { useContext } from "react"; // React Stuff
//TimeRendering
import Moment from "react-moment";
// Import global business context
import { BusinessContextConsumer } from "../../BusinessContext.js";
//Packages
import { Col, Row } from "react-bootstrap";

const ClassInfo = (props) => {
  // Handle Context
  const BusinessContext = useContext(BusinessContextConsumer);
  const { currencySymbol } = BusinessContext;
  //Get the props.
  const classinfo = props.data;

  return (
    <Row className='mt-4 mb-4 text-center'>
      <Col className='border shadow p-3'>
        <h1 className='mt-4'>Class Type: {classinfo.LessonType}</h1>
        <p>
          <strong>Venue</strong>: {classinfo.Venue.VenueName} at {classinfo.Venue.VenueAddress}.{" "}
        </p>
        <p>
          <strong>Time</strong>: {classinfo.StartTime} - {classinfo.FinishTime} on {classinfo.Day}
        </p>
        <p>
          <strong>Occupancy</strong>: {classinfo.Subscribers_Number} / {classinfo.MaxLearners}{" "}
        </p>
        <p>
          <strong>Waiting List Size</strong>: {classinfo.WaitingListSize}
        </p>
        <p>
          <strong>Description</strong>: {classinfo.ShortDescription}
        </p>
        <p>
          <strong>Price</strong>: {currencySymbol + parseFloat(classinfo.Price).toFixed(2)}
        </p>
        <p>
          <strong>Start Date</strong>: <Moment format='DD MMMM YYYY'>{classinfo.StartDate}</Moment>
        </p>
      </Col>
    </Row>
  );
};

export default ClassInfo;
